import { actionCreator } from 'utils';
import * as FormTypes from '../types/formTypes';

// L O A D   F O R M S
export function loadForms() {
    return {
        type: FormTypes.LOAD_FORMS,
    };
}

export function loadFormsRes(data) {
    return {
        type: actionCreator(FormTypes.LOAD_FORMS, 'res'),
        data,
    };
}

export function loadFormsErr() {
    return {
        type: actionCreator(FormTypes.LOAD_FORMS, 'err'),
    };
}
// L O A D   F O R M S


// S E T   F O R M   F I L T E R
export function setFormFilters(key, value) {
    return {
        type: FormTypes.SET_FORM_FILTERS,
        key,
        value,
    };
}

export function setFormPagination(key, pagination) {
    return {
        type: FormTypes.SET_FORM_PAGINATION,
        key,
        pagination,
    };
}

export function setFormSort(key, type) {
    return {
        type: FormTypes.SET_FORM_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function resetFormFilters() {
    return {
        type: FormTypes.RESET_FORM_FILTERS,
    };
}
// S E T   F O R M   F I L T E R S


// D E L E T E   F O R M
export function deleteForm(data) {
    return {
        type: FormTypes.DELETE_FORM,
        data,
    };
}

export function deleteFormRes() {
    return {
        type: actionCreator(FormTypes.DELETE_FORM, 'res'),
    };
}

export function deleteFormErr() {
    return {
        type: actionCreator(FormTypes.DELETE_FORM, 'err'),
    };
}
// D E L E T E   F O R M


// U P D A T E   F O R M
export function updateForm(data) {
    return {
        type: FormTypes.UPDATE_FORM,
        data,
    };
}

export function updateFormRes(loading, success) {
    return {
        type: actionCreator(FormTypes.UPDATE_FORM, 'res'),
        loading,
        success,
    };
}

export function updateFormErr() {
    return {
        type: actionCreator(FormTypes.UPDATE_FORM, 'err'),
    };
}
// U P D A T E   F O R M


// S E T   C H E C K E D   F O R M S
export function setCheckedForms(ids) {
    return {
        type: FormTypes.SET_CHECKED_FORMS,
        ids,
    };
}
// S E T   C H E C K E D   F O R M S
